import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-triangle', 'CircleTriangle', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M12 20l7 -12h-14l7 12"}]]);